export enum InvoiceKanbanStatus {
    Default = 'Ni izdan',
    Created = 'Ustvarjen',
    GroupInvoice = 'Odprt zbirni račun',
}
